// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__jsjfL","footer":"ModalUpdate_footer__1V5ws"};